const rules = {
  ndisNativeApi: {
    static: [
      'participants-page:visit',
      'participants-360-view-page:visit',
      'service-bookings-page:visit',
      'integration-page:visit',
      'setting-page:visit',
      'ndis-notifications-page:visit',
      'registrations-page:visit',
    ],
  },
  free: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'plans-page:visit',
      'service-bookings-page:visit',
      'setting-page:visit',
      'registrations-page:visit',
      'financial-contact-page:visit',
      'participants-360-view-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
    ],
  },
  premium: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'analytics-page:visit',
      'plans-page:visit',
      'participants-360-view-page:visit',
      'service-bookings-page:visit',
      'service-delivery-page:visit',
      'products-page:visit',
      'financial-contact-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      'setting-page:visit',
      'registrations-page:visit',
      'new-payment-page:visit',
      'online-pos-page:visit',
      'pos-devices-page:visit',
      'digital-invoice-page:visit',
      // 'posts:list',
      // 'posts:create',
      // 'users:getSelf',
      // 'home-page:visit',
      // 'dashboard-page:visit',
    ],
    dynamic: {
      'posts:edit': ({ userId, postOwnerId }) => {
        if (!userId || !postOwnerId) {
          return false;
        }
        return userId === postOwnerId;
      },
    },
  },
  planner: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'analytics-page:visit',
      'plans-page:visit',
      'service-bookings-page:visit',
      'service-delivery-page:visit',
      'participants-360-view-page:visit',
      'products-page:visit',
      'financial-contact-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      'setting-page:visit',
      'registrations-page:visit',
      'ready-to-claim-page:visit',
      'claim-recovery-page:visit',
      'claims-in-error-page:visit',
      'successful-claims-page:visit',
      'payment-cancellation-page:visit',
      'claim-batch-history-page:visit',
      'claim-batch-detail-page:visit',
      'bank-reconciliation-page:visit',
      'allocate-fund-page:visit',
      'participant-consent-page:visit',
      'remittance-page:visit',
    ],
  },
  enterprise: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'analytics-page:visit',
      'plans-page:visit',
      'service-bookings-page:visit',
      'service-delivery-page:visit',
      'products-page:visit',
      'financial-contact-page:visit',
      'new-payment-page:visit',
      'online-pos-page:visit',
      'pos-devices-page:visit',
      'registrations-page:visit',
      'digital-invoice-page:visit',
      'ready-to-claim-page:visit',
      'claim-management-page:visit',
      'claim-recovery-page:visit',
      'claims-in-error-page:visit',
      'claim-batch-history-page:visit',
      'claim-batch-detail-page:visit',
      'payment-cancellation-page:visit',
      'successful-claims-page:visit',
      'bank-reconciliation-page:visit',
      'allocate-fund-page:visit',
      'participant-consent-page:visit',
      'remittance-page:visit',
      'invoices-page:visit',
      'ready-to-invoice-page:visit',
      'issued-invoices-page:visit',
      'invoice-details-page:visit',
      'invoices-in-error-page:visit',
      'invoice-batch-history-page:visit',
      'digital-invoice-page:visit',
      'AR-invoices-page:visit',
      'out-tray-page:visit',
      'inbound-page:visit',
      'outbound-page:visit',
      'participants-360-view-page:visit',
      'setting-page:visit',
      'roster-of-care-page:visit',
      'integration-page:visit',
      'in-tray-page:visit',
      'ndis-notifications-page:visit',
      'reconciliation-page:visit', // TODO
      'budget-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      // 'posts:list',
      // 'posts:create',
      // 'posts:edit',
      // 'posts:delete',
      // 'users:get',
      // 'users:getSelf',
      // 'home-page:visit',
      // 'dashboard-page:visit',
    ],
  },
  enterprisePlusSAH: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'analytics-page:visit',
      'plans-page:visit',
      'service-bookings-page:visit',
      'service-delivery-page:visit',
      'products-page:visit',
      'financial-contact-page:visit',
      'new-payment-page:visit',
      'online-pos-page:visit',
      'pos-devices-page:visit',
      'registrations-page:visit',
      'digital-invoice-page:visit',
      'ready-to-claim-page:visit',
      'claim-management-page:visit',
      'claim-recovery-page:visit',
      'claims-in-error-page:visit',
      'claim-batch-history-page:visit',
      'claim-batch-detail-page:visit',
      'payment-cancellation-page:visit',
      'successful-claims-page:visit',
      'bank-reconciliation-page:visit',
      'allocate-fund-page:visit',
      'participant-consent-page:visit',
      'remittance-page:visit',
      'invoices-page:visit',
      'ready-to-invoice-page:visit',
      'issued-invoices-page:visit',
      'invoice-details-page:visit',
      'invoices-in-error-page:visit',
      'invoice-batch-history-page:visit',
      'digital-invoice-page:visit',
      'AR-invoices-page:visit',
      'out-tray-page:visit',
      'inbound-page:visit',
      'outbound-page:visit',
      'participants-360-view-page:visit',
      'setting-page:visit',
      'roster-of-care-page:visit',
      'integration-page:visit',
      'in-tray-page:visit',
      'ndis-notifications-page:visit',
      'reconciliation-page:visit', // TODO
      'budget-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      'support-at-home-page:visit',
      'support-at-home-care-recipient-360-page:visit',
      'support-at-home-care-recipients-page:visit',
      'support-at-home-transactions-page:visit',
      'support-at-home-ready-to-claim-page:visit',
      'support-at-home-claims-page:visit',
      'support-at-home-claim-history-page:visit',
      'support-at-home-ready-to-invoice-page:visit',
      'support-at-home-providers-page:visit',
      // 'posts:list',
      // 'posts:create',
      // 'posts:edit',
      // 'posts:delete',
      // 'users:get',
      // 'users:getSelf',
      // 'home-page:visit',
      // 'dashboard-page:visit',
    ],
  },
  supportAtHome: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'plans-page:visit',
      'service-bookings-page:visit',
      'setting-page:visit',
      'registrations-page:visit',
      'financial-contact-page:visit',
      'participants-360-view-page:visit',
      'dashboard-page:visit',
      'participants-page:visit',
      'analytics-page:visit',
      'plans-page:visit',
      'budget-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      'support-at-home-page:visit',
      'support-at-home-care-recipient-360-page:visit',
      'support-at-home-care-recipients-page:visit',
      'support-at-home-transactions-page:visit',
      'support-at-home-ready-to-claim-page:visit',
      'support-at-home-claims-page:visit',
      'support-at-home-claim-history-page:visit',
      'support-at-home-ready-to-invoice-page:visit',
      'support-at-home-providers-page:visit',
      // 'posts:list',
      // 'posts:create',
      // 'posts:edit',
      // 'posts:delete',
      // 'users:get',
      // 'users:getSelf',
      // 'home-page:visit',
      // 'dashboard-page:visit',
    ],
  },
};

export default rules;
